import {
  Routes,
  Route
} from "react-router-dom";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import Conversions from "./pages/Conversions";
import Payments from "./pages/Payments";
import Settings from "./pages/Settings";
import Help from "./pages/Help";
import NewConversions from "./pages/NewConversions";
import ConvertProgress from "./pages/ConvertProgress";
import Signup from "./pages/Signup";
import VerifyEmail from "./pages/VerifyEmail";
import UpgradePlans from "./pages/UpgradePlans";
import Pricing from "./pages/Pricing";
import Feedback from "./pages/Feedback";
import About from "./pages/About";
import ForgotPassword from "./pages/ForgotPassword";
import AddPaymentMethod from "./pages/AddPaymentMethod";
import UpdatePaymentMethod from "./pages/UpdatePaymentMethod";
import ResetPassword from "./pages/ResetPassword";
import PlanDetails from "./pages/PlanDetails";

function App() {
  return (
      <Routes>

        <Route
          path="/"
          element={<HomePage />}
        />

        <Route
          path="/login"
          element={<LoginPage />}
        />

        <Route
          path="/dashboard"
          element={<Dashboard />}
        />

        <Route
          path="/conversions"
          element={<Conversions />}
        />

        <Route
          path="/payments"
          element={<Payments />}
        />

        <Route
          path="/settings"
          element={<Settings />}
        />

        <Route
          path="/help"
          element={<Help />}
        />

        <Route
          path="/newconversions"
          element={<NewConversions />}
        />

        <Route
          path="/convertprogress"
          element={<ConvertProgress />}
        />

        <Route
          path="/signup"
          element={<Signup />}
        />

        <Route
          path="/verifyemail"
          element={<VerifyEmail />}
        />

        <Route
          path="/upgradeplans"
          element={<UpgradePlans />}
        />

        <Route
          path="/pricing"
          element={<Pricing />}
        />

        <Route
          path="/feedback"
          element={<Feedback />}
        />

        <Route
          path="/about"
          element={<About />}
        />

        <Route
          path="/forgotpassword"
          element={<ForgotPassword />}
        />

        <Route
          path="/addpaymentmethod"
          element={<AddPaymentMethod />}
        />

        <Route
          path="/updatepaymentmethod"
          element={<UpdatePaymentMethod />}
        />

        <Route
          path="/reset-password"
          element={<ResetPassword />}
        />

        <Route
          path="/pricing/:planSlug"
          element={<PlanDetails />}
        />
      </Routes>
  );
}

export default App;